<template>
  <b-card class="fixed-bottom footer-menu">
    <b-row>
      <b-col
        :class="
          currentRoute === 'dashboard'
            ? 'border selected-bg'
            : 'border no-selected-bg'
        "
      >
        <router-link class="w-100 text-center d-block" to="/">
          <i class="fas text-white fa-home icon-2x my-4"></i>
        </router-link>
      </b-col>

      <b-col
        :class="
          currentRoute === 'asistencia'
            ? 'border selected-bg'
            : 'border no-selected-bg'
        "
      >
        <router-link class="w-100 text-center d-block" to="/asistencia">
          <i class="fas fa-eye text-white icon-2x my-4"></i>
        </router-link>
      </b-col>

      <b-col
        :class="
          currentRoute === 'users'
            ? 'border selected-bg'
            : 'border no-selected-bg'
        "
      >
        <router-link class="w-100 text-center d-block" to="/users">
          <i class="fas text-white fa-sync icon-2x my-4"></i>
        </router-link>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  computed: {
    currentRoute() {
      return this.$route.name;
    }
  },
  methods: {
    disabledBtn() {
      this.$toasted.show("Módulo en construcción", {
        duration: 1500,
        type: "warning"
      });
    }
  }
};
</script>

<style>
.footer-menu .card-body {
  padding: 0;
}
.selected-bg {
  background: #625f01 !important;
}
.no-selected-bg {
  background: #bab895 !important;
}
.toasted-container .warning {
  background: #ffc105 !important;
  color: #68666a;
}
.footer-menu .icon-4x {
}
</style>
